import { Route, Routes } from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import Layout from './components/Layout'
import Home from "./pages/Accueil";
import Connexion from "./pages/Connexion";
import Analyse from './pages/Analyse'
import Documentation from './pages/Documentation'
import Historique from './pages/Historique'
import CGU from './pages/CGU'

const App = () => {
  return (
    <>
        <Layout>
          <Routes>
            <Route element={<AuthRoute />}>
                <Route path="/" element={<Home />} />
                <Route path='/analyse' element={<Analyse />} />
                <Route path='/documentation' element={<Documentation />} />
                <Route path='/history' element={<Historique />} />
            </Route>
            <Route path="/login" element={<Connexion />} />
            <Route path='/cgu' element={<CGU />} />
          </Routes>
        </Layout>
    </>
  );
};

export default App;